import {
    updateAudioState,
    resetAudioState,
    clearAudioState,
    pauseAudioState,
    playAudioState,
    setCurrentTrack,
    setAdvancedTrackData,
    doAdvancedMusicSearch,
    clearAdvancedTrackData
} from '../store/actions';

/**
 *
 */
class Player {
    constructor(props) {
        this.store = props.store;
        /**
         * Used for keeping track of the play pause interval
         */
        this.interval = null;
    }

    keepPlayingTrack() {
        const {
            audioPlayerState: {
                domRef
            }
        } = this.store.getState().music
        if (domRef) {
            if (domRef().currentTime) {
                this.playAudio()
            }
        }
    }

    async repopulateTrack() {
        const {
            audioPlayerState,
            currentTrackAdvancedData
        } = this.store.getState().music;
        const {
            item
        } = audioPlayerState;

        // console.log('FIND TRACK', currentTrackAdvancedData ?
        // currentTrackAdvancedData.items.find(i => i.id === item.id) : null)
        const trackInfo = {
            trackID: item.id ?
                item.id : currentTrackAdvancedData ?
                currentTrackAdvancedData.meta.data.id : null,
            playPause: 'play',
            songSrc: item.preview_url ?
                item.preview_url : currentTrackAdvancedData ?
                currentTrackAdvancedData.meta.data.preview_url : null,
            componentPlaying: 'track',
            item: item ?
                item : currentTrackAdvancedData ?
                currentTrackAdvancedData.meta.data : null
        }

        await this.store.dispatch(clearAdvancedTrackData())
        await this.store.dispatch(setCurrentTrack(item ?
            item :
            currentTrackAdvancedData ?
            currentTrackAdvancedData.meta.data :
            null))
        await this.store.dispatch(updateAudioState(trackInfo))
        await this.store.dispatch(doAdvancedMusicSearch())
    }

    async setCurrentTrack(item) {
        const {
            audioPlayerState
        } = this.store.getState().music;
        /**
         * Only update the track if it's different from the current track
         */
        if (audioPlayerState.trackID !== item.id) {
            this.pauseAudio();
            const trackInfo = {
                trackID: item.id,
                playPause: 'play',
                showFooterPlayer: true,
                songSrc: item.preview_url,
                componentPlaying: 'footer',
                item
            };
            this.store.dispatch(setCurrentTrack(item));
            this.updateAudio(trackInfo);
            return true;
        }
        return false;
    }

    clearAdvancedTrackData() {
        this.store.dispatch(clearAdvancedTrackData());
    }

    setAdvancedTrackData() {
        this.store.dispatch(setAdvancedTrackData());
    }

    async doAdvancedMusicSearch() {
        await this.store.dispatch(doAdvancedMusicSearch());
    }

    passBackTrack() {
        // this.store.getState().music.passTrack(this.store.getState().music.item);
        const {
            currentTrackBasicData,
            currentTrackAdvancedData,
            success,
            audioPlayerState
        } = this.store.getState().music;

        const previewUrl = success || currentTrackAdvancedData ?
            currentTrackAdvancedData ?
            currentTrackAdvancedData.meta.data.preview_url :
            currentTrackBasicData.preview_url :
            currentTrackBasicData.preview_url;

        if (previewUrl && audioPlayerState.songSrc !== previewUrl) {
            const trackInfo = {
                trackID: success || currentTrackAdvancedData ?
                    currentTrackAdvancedData ?
                    currentTrackAdvancedData.meta.data.id :
                    currentTrackBasicData.id : currentTrackBasicData.id,
                playPause: 'play',
                songSrc: previewUrl,
                componentPlaying: 'track',
                item: currentTrackBasicData ?
                    currentTrackBasicData : currentTrackAdvancedData ?
                    currentTrackAdvancedData.meta.data : null
            };
            this.store.dispatch(updateAudioState(trackInfo));
        }
    }

    clearAudioState(params) {
        const {
            audioPlayerState
        } = this.store.getState().music;
        const a = audioPlayerState.domRef();
        if (params && a) {
            a.pause();
            a.currentTime = 0;
        }
        this.store.dispatch(clearAudioState());
    }

    pausePlayAudio(forcePlay) {
        const {
            audioPlayerState
        } = this.store.getState().music;
        const a = audioPlayerState.domRef();
        if (a) {
            console.debug('Player Helper->_pausePlayAudio: Is Paused?:', a.paused);
            if (a.paused || forcePlay === true) {
                this.playAudio();
            } else {
                this.pauseAudio();
            }
        }
    }

    playAudio() {
        console.debug('Player Helper->_playAudio', this);
        const {
            audioPlayerState,
            currentTrackAdvancedData,
            currentTrackBasicData
        } = this.store.getState().music;
        const a = audioPlayerState.domRef();
        console.debug('Player Helper->_playAudio: songSrc && currentTrack', audioPlayerState, currentTrackAdvancedData, currentTrackBasicData);
        if (!audioPlayerState.songSrc) {
            console.debug('Player Helper->_playAudio: Returning because of empty data');
            return null;
        }

        console.debug('Player Helper->_playAudio: Can play track that is currently paused?', a.paused);
        a.play();
        const currentTrack = currentTrackAdvancedData ? currentTrackAdvancedData.meta.data : currentTrackBasicData;
        if (audioPlayerState.trackID !== currentTrack.id) {
            console.debug('Player Helper->_playAudio: Can play track');
            this.store.dispatch(playAudioState({
                paused: a.paused,
                currentTime: a.currentTime,
                firstAutoPlay: a.paused === true
            }));
        } else {
            console.debug('Player Helper->_playAudio: Restarting track');
            this.store.dispatch(playAudioState({
                paused: a.paused,
                currentTime: a.currentTime,
                firstAutoPlay: false
            }));
        }
    }
    pauseAudio() {
        console.debug('Player Helper->_pauseAudio: Pausing track');
        const {
            audioPlayerState
        } = this.store.getState().music;
        const a = audioPlayerState.domRef();
        a.pause();
        this.store.dispatch(pauseAudioState());
    }

    increaseSongProgress() {
        this.setState(prevState => ({
            songProgress: prevState.songProgress + 1
        }));
    }

    async updateAudio(trackInfo) {
        await this.store.dispatch(updateAudioState(trackInfo))
    }

    updateAudioProgressUntilDone(params) {
        const {
            audioPlayerState
        } = this.store.getState().music;
        const a = audioPlayerState.domRef();
        let extraState = {};
        if (params.restart || a.currentTime >= a.duration) {
            if (audioPlayerState.interval) {
                clearInterval(audioPlayerState.interval);
            }
            extraState = {
                interval: null,
                songProgress: 0
            };
            console.debug("Player Helper->updateAudioProgressUntilDone: Song is done playing");
        } else if (!audioPlayerState.interval) {
            console.debug("Player Helper->updateAudioProgressUntilDone: Starting song...", a);
            a.addEventListener('timeupdate', () => {
                console.debug("Player Helper->updateAudioProgressUntilDone: Progress");
            });
        }
        const newAudioPlayerState = {
            ...audioPlayerState,
            ...(params.state || {}),
            extraState
        };

        if (Math.floor(a.currentTime) <= 9) {
            newAudioPlayerState.currentTime = `0:0${Math.floor(a.currentTime)}`;
        }
        if (Math.floor(a.currentTime) > 9 && Math.floor(a.currentTime) < 59) {
            newAudioPlayerState.currentTime = `0:${Math.floor(a.currentTime)}`;
        }
        if (Math.floor(a.currentTime) > 59) {
            newAudioPlayerState.currentTime = `${Math.floor(a.currentTime)}`;
        }
        console.debug("Player Helper->updateAudioProgressUntilDone: Updating song progress", newAudioPlayerState.songProgress);
        this.store.dispatch(updateAudioState(newAudioPlayerState));
    }

    resetAudio(trackInfo) {
        const newTrackInfo = {
            ...trackInfo,
            ...{
                songProgress: 0,
                currentTime: '0:00'
            }
        };
        console.debug("Player Helper->resetAudio: Resetting audio");
        this.store.dispatch(resetAudioState(newTrackInfo));
    }

    handleProgress(a, component) {
        console.log("Player Helper:->_handleProgress", component.interval, a.paused);
        if (a.paused) {
            if (component.interval) {
                clearInterval(component.interval);
                component.interval = null;
            }
        } else if (!component.interval) {
            component.interval = setInterval(() => {
                if (a.currentTime >= a.duration) {
                    clearInterval(component.interval);
                    this.resetAudio({
                        showFooterPlayer: true
                    });
                    component.setState({
                        songProgress: 0,
                        currentTime: '0:00'
                    });
                } else {
                    let newAudioPlayerState = {
                        songProgress: Math.floor((a.currentTime / a.duration) * 100)
                    };
                    if (Math.floor(a.currentTime) <= 9) {
                        newAudioPlayerState.currentTime = `0:0${Math.floor(a.currentTime)}`;
                    }
                    if (Math.floor(a.currentTime) > 9 && Math.floor(a.currentTime) < 59) {
                        newAudioPlayerState.currentTime = `0:${Math.floor(a.currentTime)}`;
                    }
                    if (Math.floor(a.currentTime) > 59) {
                        newAudioPlayerState.currentTime = `${Math.floor(a.currentTime)}`;
                    }
                    //   this.updateAudio(newAudioPlayerState);
                    component.setState(newAudioPlayerState);
                }
            }, 250);
        }
    }
}

export default Player;


// WEBPACK FOOTER //
// ./src/utils/Player.js